import defaultColorPalette from "./dark_defaultPalette";

import * as colors from "../../colors";

import { DoubleExtendedPalette } from "../../models/theme.types";

const colorPalette: Partial<DoubleExtendedPalette> = {
	type: "dark",
	...defaultColorPalette,
	primary: {
		text: colors.basic[100],
		contrastText: colors.basic[100],
		dark: colors.purple[800],
		light: colors.purple[200],
		main: colors.purple[600],
		tabs: {
			border: colors.purple[500],
			contrastText: colors.purple[800],
			main: colors.purple[300]
		}
	},
	secondary: {
		text: colors.basic[200],
		contrastText: colors.purple[600],
		dark: colors.purple[800],
		light: colors.purple[200],
		main: colors.purple[200],
		tabs: {
			contrastText: colors.purple[800],
			dark: colors.purple[500],
			main: colors.purple[200],
			border: colors.purple[600]
		}
	}
};

export default colorPalette;
